const translation = {
  // NAVBAR
  nav_home: 'Home',
  nav_water: 'Water Purification',
  nav_windows: 'Windows Services',
  nav_quote: 'Get a Free Quote',

  // FOOTER
  footer_desc: 'ORPM Investment LLC delivers premium water purification systems and professional window solutions to homeowners and businesses across Georgia. Improving lives, one home at a time.',
  footer_quick_links: 'Quick Links',
  footer_our_services: 'Our Services',
  footer_contact_us: 'Contact Us',
  footer_address: '3202 Lealand Pl Ln\nLawrenceville, GA 30044',
  footer_hours: 'Mon – Fri: 8am – 6pm\nSat: 9am – 3pm',
  footer_copyright: '© 2026 ORPM Investment LLC. All rights reserved.',
  footer_licensed: 'Licensed & Insured in Georgia',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Use',
  footer_svc1: 'Whole House Filtration',
  footer_svc2: 'Drinking Water Systems',
  footer_svc3: 'Water Softeners',
  footer_svc4: 'Window Installation',
  footer_svc5: 'Window Replacement',
  footer_svc6: 'Commercial Windows',

  // HERO
  hero_badge: 'Serving Homeowners & Businesses',
  hero_title1: 'Better Water.',
  hero_title2: 'Better Living.',
  hero_title3: 'Better Homes.',
  hero_subtitle: 'Advanced water purification and professional window solutions for your home or business. Trusted by thousands of families.',
  hero_cta_water: 'Get a Free Water Test',
  hero_cta_windows: 'Request Window Quote',
  hero_trust1: 'Licensed & Insured',
  hero_trust2: '5-Star Rated',
  hero_trust3: '15+ Years Experience',
  hero_trust4: 'Free Consultations',

  // SERVICES OVERVIEW
  svc_tag: 'What We Offer',
  svc_title: 'Two Services. One Trusted Partner.',
  svc_desc: 'ORPM Investment LLC brings together two essential home improvement services under one roof — so you can trust us with everything that matters most.',
  svc_water_title: 'Water Purification Systems',
  svc_water_sub: 'Clean Water for a Healthier Life',
  svc_water_desc: 'Our advanced water filtration systems eliminate up to 99.9% of contaminants — including chlorine, lead, bacteria, and heavy metals — delivering pure, great-tasting water straight from every tap in your home.',
  svc_water_b1: 'Whole-house filtration & drinking systems',
  svc_water_b2: 'Water softeners & conditioners',
  svc_water_b3: 'NSF/ANSI certified equipment',
  svc_water_b4: 'Professional installation & service',
  svc_water_cta: 'Explore Water Systems',
  svc_water_badge: 'Water Purification',
  svc_win_title: 'Window Sales & Installation',
  svc_win_sub: 'Premium Windows for Comfort & Efficiency',
  svc_win_desc: 'From single-family homes to commercial buildings, our high-performance windows deliver superior insulation, noise reduction, and energy savings — professionally installed and backed by a lifetime warranty.',
  svc_win_b1: 'Residential & commercial installation',
  svc_win_b2: 'Energy Star certified windows',
  svc_win_b3: 'Noise reduction & UV protection',
  svc_win_b4: 'Custom sizing & impact-resistant options',
  svc_win_cta: 'Explore Window Services',
  svc_win_badge: 'Windows Services',

  // BENEFITS
  ben_tag: 'Why It Matters',
  ben_title1: 'Real Benefits for',
  ben_title2: 'Real Homeowners',
  ben_desc: 'Investing in water quality and better windows delivers measurable improvements to your health, comfort, and home value.',
  ben1_title: 'Health & Wellness',
  ben1_desc: 'Pure water reduces exposure to harmful contaminants linked to health issues. Clean water means better hydration, cooking, and overall well-being for your entire family.',
  ben1_stat_label: 'Contaminant Removal',
  ben2_title: 'Energy Efficiency',
  ben2_desc: 'Our Energy Star certified windows reduce heating and cooling costs by up to 40%, keeping your home comfortable year-round while lowering your carbon footprint.',
  ben2_stat_label: 'Energy Cost Savings',
  ben3_title: 'Home Value Boost',
  ben3_desc: 'Upgraded windows and clean water systems increase property value significantly. Buyers actively seek homes with these premium improvements built in.',
  ben3_stat_label: 'Property Value Increase',
  ben4_title: 'Quality Guaranteed',
  ben4_desc: 'Every system and installation is backed by our satisfaction guarantee and manufacturer warranty. We stand behind our work 100% — no questions asked.',
  ben4_stat_label: 'Satisfaction Guaranteed',

  // WHY CHOOSE US
  why_tag: 'Why Choose ORPM',
  why_title1: "Georgia's Trusted Home",
  why_title2: 'Improvement Partner',
  why_desc: "We've been serving homeowners and businesses for over 15 years, building a reputation for quality, reliability, and honest service. When you choose ORPM, you choose a partner who cares as much about your home as you do.",
  why_stat1: 'Years of Experience',
  why_stat2: 'Satisfied Customers',
  why_stat3: 'Specialized Services',
  why_stat4: 'Licensed & Insured',
  why_r1_title: 'Industry-Certified Professionals',
  why_r1_desc: 'Our technicians are WQA-certified and Energy Star trained. We only use equipment that meets or exceeds NSF/ANSI and EPA standards.',
  why_r2_title: 'White-Glove Customer Service',
  why_r2_desc: 'From your first call to post-installation follow-up, we make the entire process easy, transparent, and stress-free for every customer.',
  why_r3_title: 'Clean, Efficient Installations',
  why_r3_desc: 'We respect your home. Our crews arrive on time, work cleanly, and always leave the space better than they found it.',
  why_r4_title: 'Transparent, No-Surprise Pricing',
  why_r4_desc: 'Get a detailed quote before any work begins. No hidden fees, no upsells, no pressure — just honest pricing and real value.',

  // TESTIMONIALS
  test_tag: 'Customer Stories',
  test_title: 'What Our Customers Say',
  test_desc: 'Real stories from homeowners who transformed their homes with ORPM Investment LLC.',
  test1_text: 'Before ORPM, I was worried about the quality of our tap water. After installing their whole-house filtration system, the difference is night and day. The water tastes incredible and I no longer worry about what my kids are drinking. The installation team was professional and cleaned up perfectly.',
  test1_name: 'Sarah Mitchell',
  test1_loc: 'Lawrenceville, GA',
  test1_svc: 'Water Purification',
  test2_text: 'ORPM replaced all 14 windows in my home and the transformation is incredible. My electricity bill dropped by $180 in the first month! The new windows also block out so much road noise — the house feels like a different place. Highly recommend them to anyone looking for quality window work.',
  test2_name: 'Robert Keller',
  test2_loc: 'Lawrenceville, GA',
  test2_svc: 'Window Installation',
  test3_text: 'We used ORPM for both a water softener and new windows in our home. Having one company handle both was so convenient. The team was respectful, on time, and the quality of work is outstanding. Our skin and hair feel so much better with the softened water. Worth every penny!',
  test3_name: 'Maria & Carlos Lopez',
  test3_loc: 'Lawrenceville, GA',
  test3_svc: 'Water + Windows',

  // TRUST BADGES
  trust_label: 'Trusted, Certified & Backed by Industry Leaders',
  trust1_title: 'Licensed & Insured',
  trust1_sub: 'Georgia Certified',
  trust2_title: 'BBB Accredited',
  trust2_sub: 'A+ Rating',
  trust3_title: 'Energy Star',
  trust3_sub: 'Certified Partner',
  trust4_title: 'WQA Certified',
  trust4_sub: 'Water Quality',
  trust5_title: 'NSF Certified',
  trust5_sub: 'Tested Equipment',
  trust6_title: '5-Star Rated',
  trust6_sub: 'Google Reviews',

  // HOME CTA
  cta_tag: 'Take the First Step',
  cta_title1: 'Ready to Transform',
  cta_title2: 'Your Home?',
  cta_desc: "Schedule your free consultation today. Whether it's cleaner water or more efficient windows — we're here to help you improve your home and quality of life.",
  cta_water: 'Free Water Test',
  cta_windows: 'Free Window Quote',
  cta_note: 'No obligation · Free consultation · Licensed professionals',

  // WATER HERO
  wh_back: 'Back to Home',
  wh_badge: 'Water Purification',
  wh_title1: 'Clean Water for a',
  wh_title2: 'Healthier Life',
  wh_desc: "Stop worrying about what's in your water. Our advanced purification systems eliminate up to 99.9% of contaminants, delivering pure, safe water to every tap in your home.",
  wh_feature1: 'Free Water Quality Test',
  wh_feature2: 'NSF/ANSI Certified Systems',
  wh_feature3: 'Lifetime Warranty Available',
  wh_form_title: 'Schedule Your Free Water Test',
  wh_form_sub: "No cost, no obligation. We'll test your water and recommend the right solution.",
  wh_form_name: 'Full Name *',
  wh_form_phone: 'Phone *',
  wh_form_email: 'Email *',
  wh_form_zip: 'ZIP Code',
  wh_form_message: 'Tell us about your water concerns',
  wh_form_placeholder_name: 'John Smith',
  wh_form_placeholder_phone: '(555) 000-0000',
  wh_form_placeholder_email: 'john@email.com',
  wh_form_placeholder_zip: '30044',
  wh_form_placeholder_msg: 'Hard water, bad taste, odors...',
  wh_form_submit: 'Schedule My Free Water Test',
  wh_form_privacy: '100% Free · No obligation · We respect your privacy',
  wh_success_title: 'Request Submitted!',
  wh_success_desc: "We'll contact you within 24 hours to schedule your free water test.",

  // WATER PROBLEMS
  wp_tag: "Know What's In Your Water",
  wp_title1: 'What Could Be Lurking',
  wp_title2: 'In Your Tap Water',
  wp_desc: "Your water supply faces unique challenges. Here are the most common contaminants found in homes across the region — and why filtration is critical.",
  wp1_title: 'Chlorine & Chloramines',
  wp1_desc: 'Added to municipal water for disinfection, chlorine creates harmful byproducts and causes unpleasant taste and odor in drinking water.',
  wp2_title: 'Lead & Heavy Metals',
  wp2_desc: 'Aging pipes leach lead and other toxic metals into tap water. Even low levels of lead exposure can cause serious neurological damage, especially in children.',
  wp3_title: 'Bacteria & Pathogens',
  wp3_desc: 'E. coli, giardia, and other microorganisms can contaminate water supplies after floods or infrastructure failures, posing serious health risks.',
  wp4_title: 'Hard Water Minerals',
  wp4_desc: 'Calcium and magnesium build up in pipes, damage appliances, leave scale on fixtures, cause dry skin, and reduce the effectiveness of soaps and detergents.',
  wp5_title: 'Pharmaceuticals & PFAS',
  wp5_desc: 'Traces of medications, herbicides, and "forever chemicals" like PFAS increasingly appear in water supplies and are linked to hormone disruption and cancer.',
  wp6_title: 'Nitrates & Agricultural Runoff',
  wp6_desc: 'Fertilizer runoff introduces high nitrate levels into groundwater, particularly dangerous for infants and pregnant women and linked to serious health risks.',
  wp_cta_title: "Not sure what's in your water?",
  wp_cta_desc: 'Our certified water specialists will come to your home and perform a comprehensive water quality test — completely free, with no obligation to purchase.',
  wp_cta_btn: 'Get Free Test',

  // WATER SYSTEMS
  ws_tag: 'Our Systems',
  ws_title1: 'The Right Solution',
  ws_title2: 'for Every Home',
  ws_desc: 'From whole-home filtration to point-of-use drinking systems, we offer a complete range of water treatment solutions to fit any home size and budget.',
  ws1_title: 'Whole House Filtration',
  ws1_desc: 'Protect every tap, shower, and appliance in your home. Our whole-house systems filter all incoming water at the point-of-entry, removing sediment, chlorine, heavy metals, and more before it ever reaches your family.',
  ws1_f1: 'Sediment & chlorine removal',
  ws1_f2: 'Protects all appliances',
  ws1_f3: 'Covers 1–6 bathrooms',
  ws1_f4: 'Low maintenance filter changes',
  ws1_f5: 'NSF/ANSI 42/61 certified',
  ws1_badge: 'Most Popular',
  ws2_title: 'Drinking Water Systems',
  ws2_desc: 'Get premium purified water directly at your kitchen sink. Our under-counter reverse osmosis systems deliver crisp, great-tasting water with up to 99% removal of TDS, fluoride, nitrates, and pharmaceuticals.',
  ws2_f1: 'Reverse osmosis 5-stage',
  ws2_f2: 'Up to 99% TDS removal',
  ws2_f3: 'Dedicated chrome faucet',
  ws2_f4: 'Mineralizer option available',
  ws2_f5: 'Annual filter service plans',
  ws2_badge: 'Best Value',
  ws3_title: 'Home Water Purifier',
  ws3_desc: 'Eliminate hard water problems for good. Our salt-based and salt-free softeners remove calcium and magnesium, protecting your pipes, extending appliance life, and leaving your skin and hair feeling noticeably softer.',
  ws3_f1: 'Salt or salt-free options',
  ws3_f2: 'Extends appliance lifespan',
  ws3_f3: 'Reduces scale buildup',
  ws3_f4: 'Softer skin & hair',
  ws3_f5: 'Smart metered regeneration',
  ws_cta_btn: 'Get a Free Quote for This System',

  // WATER BENEFITS
  wb_tag: 'Why Purify Your Water',
  wb_title1: '6 Life-Changing Benefits',
  wb_title2: 'of Purified Water',
  wb1_title: 'Better Health for Your Family',
  wb1_text: 'Reduce exposure to chlorine, lead, and carcinogens. Purified water supports better hydration, healthier cooking, and peace of mind.',
  wb2_title: 'Superior Taste & Freshness',
  wb2_text: 'Enjoy crisp, clean water that actually tastes great — straight from the tap. No more bottled water waste or plastic pollution.',
  wb3_title: 'Save on Bottled Water',
  wb3_text: 'The average family spends $1,200+ per year on bottled water. A home purification system pays for itself in the first year.',
  wb4_title: 'Protect Your Appliances',
  wb4_text: 'Hard water destroys water heaters, dishwashers, and washing machines. Filtered water extends appliance life and reduces maintenance costs.',
  wb5_title: 'Softer Skin & Hair',
  wb5_text: 'Eliminate harsh minerals that dry out skin and dull hair. Soft, purified water transforms your daily showers and bathing experience.',
  wb6_title: 'Eco-Friendly Choice',
  wb6_text: 'Eliminate thousands of single-use plastic bottles per year. One home filtration system prevents over 2,000 bottles from reaching landfills annually.',

  // WINDOWS HERO
  wnh_back: 'Back to Home',
  wnh_badge: 'Windows Services',
  wnh_title1: 'High-Quality Windows',
  wnh_title2: 'for Comfort & Efficiency',
  wnh_desc: 'From single-family homes to commercial buildings, our premium windows deliver superior energy efficiency, noise reduction, and curb appeal — professionally installed and backed by lifetime warranty.',
  wnh_feature1: 'Energy Star Certified',
  wnh_feature2: 'Residential & Commercial',
  wnh_feature3: 'Lifetime Warranty',
  wnh_form_title: 'Get Your Free Window Quote',
  wnh_form_sub: "Tell us about your project and we'll provide a detailed, no-obligation estimate.",
  wnh_form_name: 'Full Name *',
  wnh_form_phone: 'Phone *',
  wnh_form_email: 'Email *',
  wnh_form_address: 'Property Address',
  wnh_form_service: 'Service Type',
  wnh_form_message: 'Project Details',
  wnh_form_opt0: 'Select service...',
  wnh_form_opt1: 'New Installation',
  wnh_form_opt2: 'Window Replacement',
  wnh_form_opt3: 'Residential Project',
  wnh_form_opt4: 'Commercial Project',
  wnh_form_opt5: 'Impact-Resistant Windows',
  wnh_form_placeholder_name: 'John Smith',
  wnh_form_placeholder_phone: '(555) 000-0000',
  wnh_form_placeholder_email: 'john@email.com',
  wnh_form_placeholder_address: '123 Main St, Lawrenceville, GA',
  wnh_form_placeholder_msg: 'Number of windows, property type...',
  wnh_form_submit: 'Request My Free Estimate',
  wnh_form_privacy: '100% Free · No obligation · We respect your privacy',
  wnh_success_title: 'Quote Request Received!',
  wnh_success_desc: "We'll contact you within 24 hours with your free window estimate.",

  // WINDOWS SERVICES
  wns_tag: 'Our Window Services',
  wns_title1: 'Complete Window Solutions',
  wns_title2: 'for Every Property',
  wns_desc: "Whether you're building new, replacing old windows, or upgrading to hurricane protection — we handle it all with expert craftsmanship.",
  wns1_title: 'Residential Window Installation',
  wns1_desc: 'New construction or existing homes — we install energy-efficient windows in every style and size. Our certified installers ensure a perfect fit, watertight seal, and flawless finish every time.',
  wns1_f1: 'Single, double & triple pane options',
  wns1_f2: 'Casement, bay, sliding & more',
  wns1_f3: 'Custom sizing available',
  wns1_f4: 'Professional weatherproofing',
  wns2_title: 'Window Replacement',
  wns2_desc: 'Upgrade your old, drafty, or damaged windows with modern energy-efficient alternatives. Most window replacements can be completed in a single day with minimal disruption to your home.',
  wns2_f1: 'Same-day replacement available',
  wns2_f2: 'Old window removal & disposal',
  wns2_f3: 'Frame inspection & repair',
  wns2_f4: 'Interior & exterior finishing',
  wns3_title: 'Commercial Window Services',
  wns3_desc: 'From retail storefronts to multi-story office buildings, ORPM delivers commercial-grade window solutions that reduce energy costs, enhance appearance, and meet all commercial building codes.',
  wns3_f1: 'Storefront glass systems',
  wns3_f2: 'Impact-resistant glazing',
  wns3_f3: 'Curtain wall systems',
  wns3_f4: 'ADA & code compliance',
  wns4_title: 'Impact-Resistant Windows',
  wns4_desc: 'Our impact windows meet strict specifications and protect your home from storms, break-ins, and UV damage.',
  wns4_f1: 'Storm certified',
  wns4_f2: 'Hurricane protection',
  wns4_f3: 'Improved security',
  wns4_f4: 'Insurance discount eligible',

  // WINDOWS ENERGY
  wne_tag: 'Energy Efficiency',
  wne_title1: 'Windows That Pay',
  wne_title2: 'for Themselves',
  wne_desc: 'Our Energy Star certified windows deliver measurable savings from day one. See the real numbers behind the investment.',
  wne_stat1_val: 'Up to 40%',
  wne_stat1_label: 'Reduction in Heating & Cooling Costs',
  wne_stat2_val: '2x Better',
  wne_stat2_label: 'Insulation vs. Single-Pane Windows',
  wne_stat3_val: '80%+',
  wne_stat3_label: 'UV Ray Blockage to Protect Interiors',
  wne_stat4_val: '$500+',
  wne_stat4_label: 'Annual Savings on Energy Bills',
  wne_comfort_title: 'Comfort Beyond Energy Savings',
  wne_c1_title: 'Superior Noise Reduction',
  wne_c1_text: 'Our multi-pane windows dramatically reduce outside noise by up to 50%, creating a quieter, more peaceful home environment — perfect for busy streets.',
  wne_c2_title: 'Year-Round Comfort',
  wne_c2_text: 'Advanced insulation maintains consistent indoor temperatures, keeping your home cool in summer and warm during cool winter nights.',
  wne_c3_title: 'Condensation-Free Glass',
  wne_c3_text: 'Our gas-filled double and triple-pane windows eliminate interior condensation, preventing mold, mildew, and water damage around your window frames.',
  wne_c4_title: 'Natural Light Optimization',
  wne_c4_text: 'Get all the natural light you love without the heat and UV damage. Our spectrally selective coatings transmit visible light while blocking infrared and UV.',

  // WINDOWS PROCESS
  wnp_tag: 'Our Process',
  wnp_title1: 'Easy as 1, 2, 3',
  wnp_title2: '— Actually 5',
  wnp_desc: "We made the window installation process as simple and stress-free as possible. Here's exactly what to expect.",
  wnp1_num: '01',
  wnp1_title: 'Free Consultation',
  wnp1_text: 'Call us or request online. We discuss your needs, timeline, and budget with zero pressure.',
  wnp2_num: '02',
  wnp2_title: 'In-Home Measurement',
  wnp2_text: 'Our specialist visits your property to take precise measurements and assess installation requirements.',
  wnp3_num: '03',
  wnp3_title: 'Detailed Quote',
  wnp3_text: 'Receive a transparent, itemized quote covering products, labor, and warranty. No surprises.',
  wnp4_num: '04',
  wnp4_title: 'Expert Installation',
  wnp4_text: 'Our certified crew installs your windows efficiently, on-time, and with full respect for your home.',
  wnp5_num: '05',
  wnp5_title: 'Final Inspection',
  wnp5_text: 'We walk you through every window, confirm your satisfaction, and provide all warranty documentation.',
  wnp_cta_title: 'Ready to Get Started?',
  wnp_cta_desc: 'Most projects are completed within 1–2 business days. Request your free estimate today.',
  wnp_cta_btn: 'Request Free Estimate',

  // ABOUT PAGE
  nav_about: 'About Us',
  about_hero_badge: 'Our Story',
  about_hero_title1: 'Your Trusted Home',
  about_hero_title2: 'Improvement Partner',
  about_hero_desc: 'ORPM Investment LLC was founded with a simple but powerful mission: to improve the quality of life for homeowners and businesses through better water and better homes. Based in Lawrenceville, Georgia, we\'ve grown into one of the region\'s most trusted names in water purification and window solutions.',
  about_hero_stat1_val: '15+',
  about_hero_stat1_label: 'Years of Experience',
  about_hero_stat2_val: '2,000+',
  about_hero_stat2_label: 'Happy Customers',
  about_hero_stat3_val: '2',
  about_hero_stat3_label: 'Specialized Services',
  about_hero_stat4_val: '100%',
  about_hero_stat4_label: 'Satisfaction Rate',

  about_mission_tag: 'Our Purpose',
  about_mission_title: 'Mission & Vision',
  about_mission_label: 'Our Mission',
  about_mission_text: 'To improve the quality of life for every homeowner and business we serve — through advanced water purification systems that protect health, and high-performance windows that enhance comfort, efficiency, and property value. We believe every family deserves clean water and a safe, beautiful home.',
  about_vision_label: 'Our Vision',
  about_vision_text: 'To become the leading home improvement partner in Georgia, recognized for our commitment to quality, our honesty with every customer, and our ability to deliver real, measurable improvements to the homes and lives of the communities we serve.',
  about_story_label: 'Our Story',
  about_story_text: 'ORPM Investment LLC was born from a personal experience. Our founder witnessed firsthand how contaminated water and outdated windows were silently affecting families\' health and comfort — and decided to build a company that could fix both. Starting with a small crew and a big commitment to quality, we\'ve grown to serve thousands of families across Lawrenceville and greater Georgia. Today, we\'re proud to be a team of certified professionals who bring premium solutions at honest prices.',

  about_values_tag: 'What We Stand For',
  about_values_title: 'Our Core Values',
  about_values_desc: 'These aren\'t just words on a wall. These values guide every interaction, every installation, and every decision we make at ORPM.',
  about_val1_title: 'Quality First',
  about_val1_desc: 'We only install equipment and use materials that meet the highest industry standards. No shortcuts, no compromises — ever.',
  about_val2_title: 'Built on Trust',
  about_val2_desc: 'Transparent pricing, honest assessments, and zero pressure sales tactics. We earn your trust before we earn your business.',
  about_val3_title: 'Customer Focus',
  about_val3_desc: 'Your satisfaction is our top priority — from the first phone call to years of post-installation support. We\'re here for the long run.',
  about_val4_title: 'Innovation',
  about_val4_desc: 'We stay ahead of the latest advancements in water treatment and window technology to bring you the most effective solutions available.',
  about_val5_title: 'Community Commitment',
  about_val5_desc: 'We\'re proud members of the Lawrenceville community. Local businesses, local families, and local quality — that\'s who we are.',
  about_val6_title: 'Integrity Always',
  about_val6_desc: 'We do what we say, say what we do. Our reputation is our most valuable asset, and we protect it with every job.',

  about_map_tag: 'Find Us',
  about_map_title: 'Visit Our Office',
  about_map_desc: 'We\'re conveniently located in Lawrenceville, Georgia. Stop by, call, or email us — our team is always happy to help.',
  about_map_address_label: 'Address',
  about_map_phone_label: 'Phone',
  about_map_email_label: 'Email',
  about_map_hours_label: 'Hours',
  about_map_address_val: '3202 Lealand Pl Ln\nLawrenceville, GA 30044',
  about_map_hours_val: 'Mon – Fri: 8:00 AM – 6:00 PM\nSaturday: 9:00 AM – 3:00 PM\nSunday: Closed',
  about_map_directions: 'Get Directions',
  about_cta_tag: 'Let\'s Work Together',
  about_cta_title1: 'Ready to Improve',
  about_cta_title2: 'Your Home?',
  about_cta_desc: 'Whether you need cleaner water, better windows, or both — our team is ready to help. Start with a free consultation, no strings attached.',
  about_cta_btn1: 'Free Water Test',
  about_cta_btn2: 'Free Window Quote',

  // CONTACT PAGE
  nav_contact: 'Contact',
  contact_hero_badge: 'Get in Touch',
  contact_hero_title1: 'Request Your Free',
  contact_hero_title2: 'Consultation Today',
  contact_hero_desc: 'Whether you need a water test, a window quote, or just have questions — our team is here for you. Fill out the form and we\'ll get back to you within 24 hours.',

  contact_form_title: 'Request a Free Appointment or Quote',
  contact_form_sub: 'No cost. No obligation. Our specialists will contact you within 24 hours.',
  contact_form_name: 'Full Name *',
  contact_form_phone: 'Phone *',
  contact_form_email: 'Email Address *',
  contact_form_address: 'Property Address',
  contact_form_service: 'Service of Interest *',
  contact_form_service_opt0: 'Select a service...',
  contact_form_service_opt1: 'Free Water Quality Test',
  contact_form_service_opt2: 'Water Purification System',
  contact_form_service_opt3: 'Water Softener',
  contact_form_service_opt4: 'Free Window Quote',
  contact_form_service_opt5: 'Window Installation',
  contact_form_service_opt6: 'Window Replacement',
  contact_form_service_opt7: 'Both Services (Water + Windows)',
  contact_form_message: 'Tell us about your project or questions',
  contact_form_ph_name: 'John Smith',
  contact_form_ph_phone: '(555) 000-0000',
  contact_form_ph_email: 'john@email.com',
  contact_form_ph_address: '123 Main St, Lawrenceville, GA',
  contact_form_ph_message: 'Describe your needs, current issues, or any questions you have...',
  contact_form_submit: 'Send My Request',
  contact_form_privacy: '100% Free · No obligation · We respect your privacy',
  contact_form_success_title: 'Request Sent Successfully!',
  contact_form_success_desc: 'Thank you! One of our specialists will contact you within 24 hours to schedule your free consultation.',
  contact_form_error: 'Something went wrong. Please try again or call us directly.',

  contact_info_title: 'Contact Information',
  contact_info_address_label: 'Our Location',
  contact_info_phone_label: 'Call Us',
  contact_info_email_label: 'Email Us',
  contact_info_hours_label: 'Business Hours',
  contact_info_address: '3202 Lealand Pl Ln\nLawrenceville, GA 30044',
  contact_info_hours: 'Mon – Fri: 8:00 AM – 6:00 PM\nSaturday: 9:00 AM – 3:00 PM\nSunday: Closed',
  contact_info_directions: 'Get Directions',
  contact_info_response: 'Average response time: under 2 hours during business hours.',

  contact_why_title: 'Why Contact ORPM?',
  contact_why1_title: 'Free Consultations',
  contact_why1_text: 'Every quote and water test is 100% free. No hidden fees, no pressure.',
  contact_why2_title: 'Fast Response',
  contact_why2_text: 'We respond within 24 hours — usually the same day during business hours.',
  contact_why3_title: 'Expert Advice',
  contact_why3_text: 'Our certified specialists will give you honest, tailored recommendations.',

  // BOOKING CALENDAR
  booking_section_tag: 'Book Your Appointment',
  booking_section_title: 'Schedule a Free Consultation',
  booking_section_desc: 'Pick the day and time that works best for you. Our specialists are ready to help.',
  booking_step_date: 'Select a Date',
  booking_step_time: 'Select a Time Slot',
  booking_step_form: 'Confirm Your Booking',
  booking_prev_month: 'Previous month',
  booking_next_month: 'Next month',
  booking_no_slots: 'No available slots for this day.',
  booking_label_name: 'Full Name',
  booking_label_phone: 'Phone',
  booking_label_notes: 'Additional notes (optional)',
  booking_ph_name: 'John Smith',
  booking_ph_phone: '(555) 000-0000',
  booking_ph_notes: 'Tell us about your consultation, service of interest...',
  booking_selected_date: 'Date:',
  booking_selected_time: 'Time:',
  booking_modify_time: 'Change time',
  booking_submit: 'Confirm Booking',
  booking_submitting: 'Sending...',
  booking_success_title: 'Appointment Confirmed!',
  booking_success_desc: 'Your booking was successfully registered. We will contact you to confirm the details.',
  booking_error: 'Something went wrong. Please try again or call us directly.',
  booking_back: 'Book another appointment',
  booking_loading: 'Loading availability...',
  booking_required: '*',
};

export default translation;
